import * as React from 'react';

import { useSetAtom } from 'jotai';

import { $populateItemGroupFormAction } from '../_state/itemGroupForm.state';
import { ItemGroupRecord } from '../types/inventoryItem';

type Props = {
  itemGroup: ItemGroupRecord | null | undefined;
};

export const usePopulateItemGroupForm = ({ itemGroup }: Props) => {
  const populateForm = useSetAtom($populateItemGroupFormAction);

  React.useEffect(() => {
    populateForm(itemGroup);
  }, [itemGroup, populateForm]);
};
